module.exports = __webpack_public_path__ + "media/packs/images/flags/NO-9e5df7fa5e459b872a1fe1090421f096.svg";